import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective],
  template: `
    <div
      class="truncate"
      #text
      [auxTooltip]="text.offsetWidth < text.scrollWidth ? params.value : ''"
    >
      {{ params.valueFormatted || params.value || utils.zeroHyphen }}
    </div>
  `,
})
export class AgTooltipComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  readonly utils = Utils;

  agInit(params: ICellRendererParams) {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
